import React from 'react';
import * as cls from './button.module.css';

export const Button = ({
  children,
  className,
  loading,
  size,
  type = 'button',
  variant = 'orange',
  ...rest
}) => {
  let klass = `${cls.button} ${loading ? cls.loading : ''} ${size ? cls[size] : ''} ${cls[variant]} ${className || ''}`;
  return (
    <button className={klass} type={type} {...rest}>
      {children}
    </button>
  );
};
